// extracted by mini-css-extract-plugin
module.exports = {"footer":"bddrMGjOZnMvU0V1pPpKa","button":"_1izY3loa5h3zP2lh24hgUB"};